import { useMemo } from "react";
import { Field, reduxForm, SubmissionError } from "redux-form";
import { Button, Input } from "expano-components";

import { Main, Dashboard, Select } from "components";

import useGet from "hooks/useGet";
import useCreate from "hooks/useCreate";

import { ReactComponent as ProductIcon } from "icons/product.svg";

const InputField = (props) => <Input {...props} />;
const SelectField = (props) => <Select {...props} />;

const RootTaxonNew = ({ handleSubmit, change, pristine, history, invalid }) => {
  const { data: root_taxons } = useGet({
    query: ["root_taxons"],
    path: "/root_taxons",
    context: "list",
    search: { per_page: 10_000 },
  });

  const { is_creating, create } = useCreate({
    path: "/root_taxons",
    onSuccess: ({ id }) => {
      history.push(`/root_taxons/${id}`);
    },
    onError: (err) => {
      throw new SubmissionError(
        Object.fromEntries(
          Object.entries(err).map(([key, value]) => {
            if (["parent"].includes(key)) {
              return [`${key}_id`, value];
            }
            return [key, value];
          })
        )
      );
    },
  });

  const root_taxons_options = useMemo(() => {
    return root_taxons?.map(({ id, name, identifier }) => ({
      label: `[${identifier}] ${name}`,
      value: id,
    }));
  }, [root_taxons]);

  const onSubmit = (values) => create(values);

  return (
    <Main
      page={{
        name: "Dodaj kategorię root",
        icon: <ProductIcon />,
        breadcrumbs: [
          {
            name: "Kategorie root",
            path: "/root_taxons",
          },
          { name: "Dodaj kategorię root" },
        ],
      }}
    >
      <div className="dashboard-wrapper-flex">
        <div className="column-half">
          <Dashboard
            header={{ title: "Podstawowe informacje", icon: "info" }}
            footer={
              <>
                <Button
                  type="cancel"
                  onClick={() => history.push("/root_taxons")}
                />
                <Button
                  type="save"
                  text={is_creating ? "Proszę czekać..." : "Utwórz"}
                  disabled={pristine || invalid || is_creating}
                  onClick={handleSubmit(onSubmit)}
                />
              </>
            }
          >
            <form
              className="dashboard__form"
              onSubmit={handleSubmit(onSubmit)}
              noValidate
            >
              <Field
                name="name"
                label="Nazwa"
                component={InputField}
                type="text"
              />
              <Field
                name="identifier"
                label="Identyfikator"
                component={InputField}
                type="text"
              />
              <Field
                label="Rodzic"
                name="parent_id"
                component={SelectField}
                options={root_taxons_options}
                handleChange={(value) => {
                  change("parent_id", value);
                }}
              />
            </form>
          </Dashboard>
        </div>
      </div>
    </Main>
  );
};

const validate = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = "Nazwa jest wymagana!";
  }

  if (!values.identifier) {
    errors.identifier = "Identyfikator jest wymagany!";
  }

  return errors;
};

export default reduxForm({
  form: "create-root-taxon",
  enableReinitialize: true,
  validate,
})(RootTaxonNew);
